import * as z from "zod/v4";
import { AeoPromptSchema } from "./schemas/aeo-prompt";

export const getAeoPromptDetails = {
  name: "getAeoPromptDetails" as const,
  input: z.object({ promptId: z.bigint() }),
  output: AeoPromptSchema.nullable(),
};
